import React from 'react'
import { ClipLoader } from 'react-spinners'

const Loader = () => {
  return (
    <ClipLoader color="#E67E22" size={50} />
  )
}

export default Loader